import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { AuthGuardData } from 'keycloak-angular';
import { createAuthGuard } from 'keycloak-angular';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

const authGuardFn = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!authData.authenticated) {
    await authData.keycloak.login();
    return false;
  }
  const allowed = await auth.validateAdminAccess();
  if (!allowed) {
    router.navigate(['/unauthorized']);
    return false;
  }
  const hasAyaGroupAccess = await auth.validateAyaGroupAccess();
  if (!hasAyaGroupAccess) {
    router.navigate(['/unauthorized'], { state: { reason: 'missing-aya-group' } });
    return false;
  }
  return true;
};

export const authGuard = createAuthGuard(authGuardFn);
